import { useNavigate } from 'react-router-dom';
import { useCompanyRelativePath } from 'ogp/hooks';
import { routes } from 'Routes';
import type { UseMutationOptions } from 'react-query';
import { useArchiveWorkflow } from './use-archive-workflow';
import type { sharedWorkflowService } from '../../../../../../api/services';
import type { SecondParamOfFn } from '../../../../../../types';

type UserMutationOptions = UseMutationOptions<
  unknown,
  Error,
  SecondParamOfFn<typeof sharedWorkflowService.archiveWorkflow>
>;
export const useGetWorkflowActionHandlers = (options?: { archiveOptions: UserMutationOptions }) => {
  const navigate = useNavigate();
  const generatePath = useCompanyRelativePath();
  const archiveWorkflowMutation = useArchiveWorkflow(options?.archiveOptions);

  const handleViewWorkflow = (workflowId: string) => {
    // TODO LW1-26655 frontend-webapp-view-existing-workflow
    navigate(generatePath(routes.WorkflowsCreate, { id: workflowId }));
  };

  const handleArchiveWorkflow = (workflowId: string) => {
    archiveWorkflowMutation.mutate(workflowId);
  };

  return {
    handleViewWorkflow,
    handleArchiveWorkflow,
  };
};
